/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdfviewer_Unsupportedbrowserdescription3Inputs */

const en_pdfviewer_unsupportedbrowserdescription3 = /** @type {(inputs: Pdfviewer_Unsupportedbrowserdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viewing PDF documents requires a newer browser version. Please update your browser to continue.`)
};

/**
* | output |
* | --- |
* | "Viewing PDF documents requires a newer browser version. Please update your browser to continue." |
*
* @param {Pdfviewer_Unsupportedbrowserdescription3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const pdfviewer_unsupportedbrowserdescription3 = /** @type {((inputs?: Pdfviewer_Unsupportedbrowserdescription3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdfviewer_Unsupportedbrowserdescription3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_pdfviewer_unsupportedbrowserdescription3(inputs)
});
export { pdfviewer_unsupportedbrowserdescription3 as "pdfViewer_unsupportedBrowserDescription" }